export default "__VITE_ASSET__f$Abu_WV__"